import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#027BC6',
      light: '#4A9BD6',
      dark: '#015A8A',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#0AD69F',
      light: '#4DE4B8',
      dark: '#07A67A',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#EF476F',
      light: '#F47A96',
      dark: '#D63A5A',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#EF456E',
      light: '#F47A96',
      dark: '#D63A5A',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F8F8F8',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#000000',
      secondary: '#38485C',
      disabled: '#9A9A9A',
    },
    grey: {
      50: '#F9FAFC',
      100: '#F8F8F8',
      200: '#E3E3E3',
      300: '#D1D5DB',
      400: '#9A9A9A',
      500: '#919191',
      600: '#6B7280',
      700: '#38485C',
      800: '#1F2937',
      900: '#000000',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.3,
    },
    h3: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4,
    },
    h4: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
    h5: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      fontSize: '1.125rem',
      lineHeight: 1.5,
    },
    h6: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body1: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    button: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
          height: '64px',
          fontFamily: '"Montserrat", sans-serif',
        },
        containedPrimary: {
          backgroundColor: '#027BC6',
          boxShadow: '0px 5px 20px #00000022',
          '&:hover': {
            backgroundColor: '#015A8A',
          },
          '&:disabled': {
            backgroundColor: '#9A9A9A',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 6px 26px rgba(98, 107, 125, 0.07)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            height: '64px',
            backgroundColor: '#FFFFFF',
            border: '1px solid #E3E3E3',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#027BC6',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#027BC6',
            },
            '& input::placeholder': {
              color: '#AFB0B2',
              opacity: 1,
              fontFamily: '"Montserrat", sans-serif',
              fontWeight: 600, // Semibold as requested
            },
            '& input': {
              paddingLeft: '30px', // Left padding for placeholder text
            },
          },
          '& .MuiInputLabel-root': {
            fontFamily: '"Montserrat", sans-serif',
            '&.Mui-focused': {
              color: '#027BC6',
            },
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          '&.Mui-checked': {
            color: '#027BC6',
          },
          '& .MuiSvgIcon-root': {
            borderRadius: 4,
            border: '1px solid #027BC6',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;
